import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './styles/globals.css';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1F2A22',
            color: '#F4ECDF',
            border: '1px solid rgba(94,123,62,.35)',
            fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
            fontSize: '14px',
            borderRadius: '12px',
            padding: '12px 14px',
            boxShadow: '0 12px 28px -18px rgba(38,32,26,.45)',
          },
          success: { iconTheme: { primary: '#5E7B3E', secondary: '#F4ECDF' } },
          error: {
            style: {
              background: '#F6E0DC',
              color: '#8A2C22',
              border: '1px solid #E6B8B0',
            },
            iconTheme: { primary: '#B0392C', secondary: '#F6E0DC' },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
);
